import { useLayoutEffect, useRef } from 'react'

const guards = new Map<symbol, string>()
export const REFRESH_GUARDS_CHANGED = 'bramble:refresh-guards-changed'
export function refreshBlocker() { return guards.values().next().value as string | undefined }

// These are drafts or operations outside the story autosave. Never silently
// submit a form, send a chat draft, or abandon an upload to install an update.
export function useRefreshGuard(blocked: boolean, message: string) {
  const id = useRef(Symbol())
  useLayoutEffect(() => {
    if (!blocked) return
    guards.set(id.current, message)
    window.dispatchEvent(new Event(REFRESH_GUARDS_CHANGED))
    return () => { guards.delete(id.current); window.dispatchEvent(new Event(REFRESH_GUARDS_CHANGED)) }
  }, [blocked, message])
}
